import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
          準備讓企業升級更有方向？
        </h2>
        <p className="text-sm md:text-base text-foreground-700 mb-10 max-w-2xl mx-auto leading-relaxed">
          無論您正在尋找政府資源、規劃 AI 導入、整理財稅管理，或準備面對 ESG 永續要求，得運智科都能協助您從現況診斷開始，找到更適合企業的下一步。
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 bg-primary-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-primary-700 transition-colors duration-200 whitespace-nowrap shadow-lg shadow-primary-600/20"
        >
          立即預約諮詢
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white" />
          </div>
        </Link>
      </div>
    </section>
  );
}